export enum DistributionAreaApiUrls {
    GetDistributionAreas='/api/DistributionArea/GetDistributionAreasByDistributionLaneId',
  }
